import { AppDistributionList } from '../Apps';
import AppManagementRequest from './AppManagementRequest';

//appDistributionList: AppDistributionList
export default class AppDistributionListRequest extends AppManagementRequest {
	constructor(app, createdBy, appDistributionList) {
		super(app, createdBy);
		this.appDistributionList = appDistributionList
			? new AppDistributionList(appDistributionList)
			: new AppDistributionList();
	}
}
